import config from 'Cloud/config';

export const ON_PREMISE_WHITELIST_DOMAINS: string[] | false = config.get('ON_PREMISE_WHITELIST_DOMAINS');
